//questionnaire页面所需数据

import { name } from "file-loader";

export const questionnaire = [
  "कृपया प्रत्येक संशोधन प्रश्न के साथ सच्चा जानकारी से पढ़ने और प्रतिक्रिया के लिए अपना समय ले लें. आपको संशोधनों के साथ पैसा बनाने के लिए अवसर दिया गया है क्योंकि संशोधकों को अपने मूल्य इनपुट की जरूरत है। यदि तुम सच्चे नहीं हो तो तुम्हारे जवाब उपयोगी नहीं हैं, और तुम जल्दी में अपने आपको पूरा करने के लिए कोई संशोधन नहीं पाओगे। ",
  "तुम्हारे संशोधन सत्रों को संपूर्ण रूप से गुप्त रूप से रखना होगा और आप उसके सामग्री में से किसी के साथ साझा नहीं कर सकते, पाठ, छव यह भी मतलब है कि आप अन्यों को क्या जवाब देने के लिए नहीं दिखा सकते हैं जो उन्हें क्या प्राप्त करने के लिए मदद कर सकते हैं, किसी पद्धति के द्व"
];

//rewards下一级所需数据
export const paypal = {
  imgurl: require("@/assets/pcImg/paypal.png"),
  name: "PayPal",
  title: "PayPal पुनरावृत्ति: अपना पैपPal पैमेंट चुनें",
  pList: [
    "पैसा सीधे अपने PayPal खाते में रखें और लाखों ऑनलाइन दुकानों में उपयोग करें. ",
    "आपके पैसा के सबसे जल्दी प्रदान के लिए, हम सिफारिस करते हैं कि आपके पैपाल खाता इमेल आपके खाता के लिए रेजिस्टरिज़र्ज़ आपका पहला और अंतिम नाम अपने PayPal खाता जानकारी के साथ सच्चा मेल होना चाहिए और आपके PayPal खाता को सत्यापित करना चाहिए. अपने PayPal खाता को सत्यापित करने के लिए PayPal स्मार्ट कनेक्ट के लिए, या PayPal Plus MasterCard® के लिए स्वीकारित किया जा रहा है. ",
    "आपके PayPal खाता को सत्यापित करने के लिए, हम निम्न लिंक को नीचे प्रदान किया है. यदि आपको पैपपैल परीक्षण पूरा करने के लिए समस्या है, कृपया पैपपैल को सीधे सीधे संपर्क करें."
  ],
  explain:
    "* जबकि हर प्रयास अपने विमुक्ति का प्रक्रिया करने के लिए जल्दी से जल्दी होता है, प्रतिज्ञा प्राप्त करने के लिए 10 व्यवसाय दिन तक ले स"
};
export const walmart = {
  imgurl: require("@/assets/pcImg/walmart.png"),
  name: "Walmart",
  title: "PayPal पुनरावृत्ति: अपना पैपPal पैमेंट चुनें",
  pList: [
    "पैसा सीधे अपने PayPal खाते में रखें और लाखों ऑनलाइन संग्रहों में उपयोग करें.",
    "आपके पैसा के सबसे जल्दी प्रदान के लिए, हम सिफारिस करते हैं कि आपके पैपाल खाता इमेल आपके खाता के लिए रेजिस्टरिज़र्ज़ आपका पहला और अंतिम नाम अपने PayPal खाता जानकारी के साथ सच्चा मेल होना चाहिए और आपके PayPal खाता को सत्यापित करना चाहिए. अपने PayPal खाता को सत्यापित करने के लिए PayPal स्मार्ट कनेक्ट के लिए, या PayPal Plus MasterCard® के लिए स्वीकारित किया जा रहा है. ",
    "आपके PayPal खाता को सत्यापित करने के लिए, हम निम्न लिंक को नीचे प्रदान किया है. यदि आपको पैपपैल परीक्षण पूरा करने के लिए समस्या है, कृपया पैपपैल को सीधे सीधे संपर्क करें."
  ],
  explain:
    "* जबकि हर प्रयास अपने विमुक्ति का प्रक्रिया करने के लिए जल्दी से जल्दी है, प्रतिदान 10 व्यवसाय दिन तक ले सकता है, हालाँकि वे सामान्य "
};
export const amazon = {
  imgurl: require("@/assets/pcImg/amazon.png"),
  name: "Amazon",
  title: "अमेज़ोन रिवर्ड्स: अपने अमेज़ोन गिफ्ट कार्ड चुनें",
  pList: [
    "वीसेन्स Amazon.com की बड़ी चयन किताब, इलेक्ट्रोनिक, संगीत, डीवीडी, वीडियो, एपारेल, कम्प्यूटर, साफटवेयर, स्पोर्ट, खेल, बेबी, कम्प्यूटर & वीडियो खेल, किचेन & हुसवेयर, जुवेली, सुंदर, सेल फोन्स & से Amazon.com है जिस चीज़ को आप ऑनलाइन खरीद करना चाहते हैं उसे ढूंढने और खोज करने के लिए. ",
    "कैनाडा के रिसिडेन्स - कृपया टिप्पणी: Amazon.com प्रदान कार्ड अमाजान.ca पर पुनरावृत्ति नहीं कर सकते.",
    "*Amazon.com इस प्रगति का स्पोन्सर नहीं है. सिवाय व्यवस्था के द्वारा आवश्यक है, जीकीएस मूल्य के लिए स्थानान्तरित नहीं किया जा सकता है या पैसा के ल जीकी सिर्फ Amazon.com में या उसके संबंधित वेब साइटों में से कुछ अधिकारित सामग्री के लिए केवल उपयोग किया जा सकता है. पूरा शर्त और परिस्थिति के लिए, www.amazon.com/gc-legal देखें. जीके एसीआई गिफ्ट कार्ड, इंक्यूटिंग, एक वाशिंग्टन कॉर्पोरेशन द्वारा निर्गत हैं. ©,®,™ Amazon.com Inc. और/या उसके संबंधित, 2013."
  ],
  explain:
    "* जबकि हर प्रयास अपने विमुक्ति का प्रक्रिया करने के लिए जल्दी से जल्दी है, प्रतिदान 3 - 10 व्यवसाय दिन तक ले सकता है, हालाँकि वे सामान्य "
};

// 首页问题
// 那一年买的车 当前时间往前推20年
export const buyCarDate = () => {
  // 获取当前时间
  const date = new Date();
  const nowYear = date.getFullYear();
  const options = [];
  for (let i = 19; i >= 0; i--) {
    const item = {
      id: nowYear - i,
      title: nowYear - i
    };
    options.unshift(item);
  }
  return options;
};

//是否有小孩
export const isHavingChildren = () => {
  const options = [
    {
      id: 1,
      title: "Yes"
    },
    {
      id: 2,
      title: "No"
    }
  ];
  return options;
};

//小孩是那一年出生的
export const childrenBirthday = () => {
  const date = new Date();
  const nowYear = date.getFullYear();
  const options = [];
  for (let i = 17; i >= 0; i--) {
    const item = {
      id: nowYear - i,
      title: nowYear - i
    };
    options.unshift(item);
  }
  return options;
};



// WEBPACK FOOTER //
// ./src/utlis/storageData.js